import { gql } from '@apollo/client';

export const GET_HIERARCHY_GROUP_QUERY = gql`
  query SalesWebHierarchyGroup($id: ID!) {
    clarkeClientGroup(id: $id) {
      id
      name
      legalName
      docType
      docNumber
      companies {
        id
        name
        legalName
        docType
        docNumber
        clientId
      }
    }
  }
`;
